module.exports = __webpack_public_path__ + "media/images/bgsplash-24314df47515cf4c8a407f79d9b86b50.png";